import { useCallback, useState } from 'react';

export const useMapCardInteraction = () => {
  const [selectedMarkerId, setSelectedMarkerId] = useState<string | undefined>();

  const onCardHover = useCallback((id: string) => {
    setSelectedMarkerId(id);
  }, []);

  const onCardHoverLeave = useCallback(() => {
    setSelectedMarkerId(undefined);
  }, []);

  const onMarkerClick = useCallback((id: string) => {
    setSelectedMarkerId((prev) => (prev === id ? undefined : id));
  }, []);

  return { selectedMarkerId, onCardHover, onCardHoverLeave, onMarkerClick };
};
